module.exports = __webpack_public_path__ + "images/4273306bb3aad9e4efaf6acb7f4b6df3-IMG_4482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_4482.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_4482.jpg
// module chunks = 0